const Backbone = require('backbone');
require('jquery.scrollto');
var FinishNameView = Backbone.View.extend({
	el: '.js-finish-name',

	events: {
		click: '_toggleFinishes'
	},

	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.render);
		this.listenTo(Backbone, 'finish:notSelected', this.highlightError);
		this.listenTo(Backbone, 'finish:hover', this.render);
		self.isPopoverVisible = false;

		if (window.BCOM.device.isMobile) {
			delete this.events.click;
			this.delegateEvents();
		}
	},

	render: function(data) {
		if (data.name && data.name.trim().match(/^n\/?a$/i)) {
			this.$el.addClass('hide');
			data.name = '';
		} else {
			this.$el.removeClass('hide');
		}
		if (window.dataLayer.isPla) {
			$('.js-finish-label').removeClass('error-highlight');
		} else {
			this.$el.removeClass('error-highlight');
		}

		if (window.BCOM.device.isMobile && this.$el.text() !== data.name) {
			this.$el.hide();
			this.$el.text(data.name).fadeIn(700);
		} else {
			this.$el.html(data.name);
		}
		window.dataLayer.selectedFinishName = data.name;
		if (data.uniqueId) {
			window.dataLayer.selectedFinishId = data.uniqueId;
		}
	},

	highlightError: function() {
		if (!window.BCOM.device.isMobile) {
			if (window.dataLayer.isPla) {
				$('.js-finish-label').addClass('error-highlight');
			} else {
				this.$el.addClass('error-highlight');
			}

			if (!window.BCOM.util.isElementInViewport(this.$el)) {
				$(window).scrollTo(this.$el.offset().top - 50, 500);
			}
		}
	},
	_toggleFinishes: function(event) {
		if (event) {
			event.stopPropagation();
		}
		this.$el.popover('toggle');
		this.isPopoverVisible = !this.isPopoverVisible;
		Backbone.trigger('finishes:popover');
	}
});

module.exports = FinishNameView;
